export enum ELocalToServerReplicationMode {
	classic = "classic",
	changeTracking = "changeTracking"
}
